import { db } from '../firebase';
import { collection, addDoc, doc, updateDoc, increment, getDoc, setDoc, query, where, getDocs } from 'firebase/firestore';
import { Subscription, SubscriptionStats, LikeEntry } from '../data/interface';

export class SubscriptionService {
    private subscriptionsRef = collection(db, 'subscriptions');
    private statsRef = doc(db, 'subscriptions', '_stats');
    private likesRef = collection(db, 'likes');

    async addSubscription(email: string, isDJ: boolean) {
        try {
            // Check if email already exists
            const emailQuery = query(this.subscriptionsRef, where('email', '==', email));
            const querySnapshot = await getDocs(emailQuery);
            
            if (!querySnapshot.empty) {
                throw new Error('Email already subscribed');
            }

            const docRef = await addDoc(this.subscriptionsRef, {
                email,
                isDJ,
                createdAt: new Date()
            });

            const subscription: Subscription = {
                id: docRef.id,
                email,
                isDJ,
                createdAt: new Date()
            };

            await updateDoc(this.statsRef, {
                djCount: increment(1)
            });

            return docRef.id;
        } catch (error) {
            console.error('Error adding subscription:', error);
            throw error;
        }
    }

    async addLike(ip: string) {
        try {
            // Check if this IP has already liked
            const ipQuery = query(this.likesRef, where('ip', '==', ip));
            const querySnapshot = await getDocs(ipQuery);
            
            if (!querySnapshot.empty) {
                throw new Error('IP has already liked');
            }

            // Add the like entry
            await addDoc(this.likesRef, {
                ip,
                timestamp: new Date()
            });

            // Check if stats document exists
            const statsDoc = await getDoc(this.statsRef);

            if (!statsDoc.exists()) {
                // Create stats document if it doesn't exist
                const initialStats: SubscriptionStats = {
                    likes: 0,
                    djCount: 0
                };
                await setDoc(this.statsRef, initialStats);
            } else {
                // Update existing stats document
                await updateDoc(this.statsRef, {
                    likes: increment(1)
                });
            }
        } catch (error) {
            console.error('Error incrementing likes:', error);
            throw error;
        }
    }

    async addDJCount() {
        try {
            // Check if stats document exists
            const statsDoc = await getDoc(this.statsRef);

            if (!statsDoc.exists()) {
                // Create stats document if it doesn't exist
                const initialStats: SubscriptionStats = {
                    likes: 0,
                    djCount: 0
                };
                await setDoc(this.statsRef, initialStats);
            } else {
                // Update existing stats document
                await updateDoc(this.statsRef, {
                    djCount: increment(1)
                });
            }
        } catch (error) {
            console.error('Error incrementing DJ count:', error);
            throw error;
        }
    }

    async getStats() {
        const statsDoc = await getDoc(this.statsRef);
        return statsDoc.data() as SubscriptionStats;
    }
}

export const subscriptionService = new SubscriptionService();
